import React, { useState } from 'react';
import { Box, Typography, Button, IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const BottomBar = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const userID = useSelector((state) => state.auth.userID);
  const showChat = useSelector((state) => state.user.showChat);
  const isAuthenticated = useSelector((state) => state.auth.authenticated);
  const provider = useSelector((state) => state.user.provider);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleGetStarted = () => {
    if (userID) {
      window.open(`https://ore-skm-prototypes.skillsminer.ai/user/${userID}`, '_blank');
    }
  };

  // Only show for specific providers and if user is authenticated and chat is finished
  const allowedProviders = [
    'orecatapult#orecatapultprovider',
    'usagetest#usagetestprovider', 
    'torrengroup#torrengroupemployees'
  ];

  if (!isAuthenticated || showChat || !allowedProviders.includes(provider)) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#FF6B35',
        color: 'white',
        padding: isExpanded ? '24px 24px' : '8px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        zIndex: 1000,
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        transition: 'padding 0.3s ease',
      }}
    >
      {isExpanded && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', marginLeft: 'auto' }}>
          <Typography variant="h6" sx={{ fontWeight: 500 }}>
            Taking part in the Catapult pilot - click here to find out more
          </Typography>
          <Button
            variant="contained"
            onClick={handleGetStarted}
            sx={{
              backgroundColor: 'white',
              color: '#FF6B35',
              fontWeight: 'bold',
              padding: '12px 24px',
              fontSize: '16px',
              '&:hover': {
                backgroundColor: '#f5f5f5',
              }
            }}
          >
            Get Started
          </Button>
          <IconButton
            onClick={toggleExpanded}
            sx={{
              color: 'white',
              padding: '4px',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
              }
            }}
          >
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      )}
      
      {!isExpanded && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', width: '100%', justifyContent: 'flex-end' }}>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Taking part in the Catapult pilot - click here to find out more
          </Typography>
          <IconButton
            onClick={toggleExpanded}
            sx={{
              color: 'white',
              padding: '4px',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
              }
            }}
          >
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default BottomBar;
